__turbopack_context__.v({
  "acts": "signin-module__IEvyqa__acts",
  "arrive": "signin-module__IEvyqa__arrive",
  "brand": "signin-module__IEvyqa__brand",
  "chip": "signin-module__IEvyqa__chip",
  "chips": "signin-module__IEvyqa__chips",
  "err": "signin-module__IEvyqa__err",
  "extras": "signin-module__IEvyqa__extras",
  "field": "signin-module__IEvyqa__field",
  "fine": "signin-module__IEvyqa__fine",
  "form": "signin-module__IEvyqa__form",
  "names": "signin-module__IEvyqa__names",
  "reasons": "signin-module__IEvyqa__reasons",
  "screen": "signin-module__IEvyqa__screen",
  "screen-in": "signin-module__IEvyqa__screen-in",
  "sentMark": "signin-module__IEvyqa__sentMark",
  "sentNote": "signin-module__IEvyqa__sentNote",
});
